import { createGeometryApi } from "@org-avp/avp-avengers-geometry-service-api";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../utils/header.utils";

const defaultPageSize = 5_000;
const baseQueryArgs: Parameters<typeof fetchBaseQuery>[0] = {
  baseUrl: environment.NX_GEOMETRY_SERVICE_BASE_URL,
  prepareHeaders,
};

export const geometryApi: ReturnType<typeof createGeometryApi> = createGeometryApi({
  pageSize: defaultPageSize,
  baseQueryArgs,
});
